import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class SevaProfileService {

  private baseUrl = environment.apiUrl; // Base URL from environment.ts
  private documentsEndpoint = 'FileHandler/GetAllDocuments';
  private documentsUploadEndpoint = 'FileHandler/UploadFile';


  constructor(private http: HttpClient) { }




  
  
  private sanitizeUrl(url: string): string {
    // Fix case: multiple "?" → only first is "?", others become "&"
    let fixed = url.replace(/\?/g, (match, offset) => (offset === url.indexOf('?') ? '?' : '&'));

    // Remove accidental double && or ?? 
    fixed = fixed.replace(/&&+/g, '&').replace(/\?\?+/g, '?');

    // Remove trailing & or ?
    fixed = fixed.replace(/[&?]+$/, '');

    return fixed;
  }

  apiCall<T>(
    endpoint: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    body?: any,
    params?: Record<string, any>
  ): Observable<T> {
    let url = `${this.baseUrl}${endpoint}`;

    // Append params if provided
    if (params) {
      const queryString = Object.entries(params)
        .filter(([_, v]) => v !== null && v !== undefined)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');

      url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
    }

    // Sanitize to fix bad query formatting
    url = this.sanitizeUrl(url);

    switch (method) {
      case 'GET':
        return this.http.get<T>(url);
      case 'POST':
        return this.http.post<T>(url, body);
      case 'PUT':
        return this.http.put<T>(url, body);
      case 'DELETE':
        return this.http.delete<T>(url);
      default:
        throw new Error(`Unsupported request method: ${method}`);
    }
  }



  apiCall1<T>(endpoint: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', body?: any): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;

    switch (method) {
      case 'GET':
        return this.http.get<T>(url, );
      case 'POST':
        return this.http.post<T>(url, body,);
      case 'PUT':
        return this.http.put<T>(url, body);
      case 'DELETE':
        return this.http.delete<T>(url);
      default:
        throw new Error(`Unsupported request method: ${method}`);
    }
  }




  // Upload a document using multipart/form-data
  uploadDocument<T = any>(
    documentType: number,
    file: File,
    endpoint: string,
    extra?: { applicationTypeId?: number; note?: string; fileNameOverride?: string }
  ): Observable<T> {
    const formData = new FormData();
    formData.append('formFile', file, extra?.fileNameOverride ?? file.name);
    if (extra?.applicationTypeId !== undefined) {
      formData.append('applicationTypeId', String(extra.applicationTypeId));
    }
    if (extra?.note) {
      formData.append('note', extra.note);
    }

    const url = `${this.baseUrl}${endpoint}`;
    const params = new HttpParams().set('gspDocType', String(documentType));
    return this.http.post<T>(url, formData, { params });
  }

  // Upload multiple documents using multipart/form-data
  uploadMultipleFiles<T = any>(
    documentType: number,
    files: File[],
    endpoint: string,
    extra?: { applicationTypeId?: number; note?: string }
  ): Observable<T> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('formFiles', file, file.name);
    });
    
    if (extra?.applicationTypeId !== undefined) {
      formData.append('applicationTypeId', String(extra.applicationTypeId));
    }
    if (extra?.note) {
      formData.append('note', extra.note);
    }

    const url = `${this.baseUrl}${endpoint}`;
    const params = new HttpParams().set('gspDocType', String(documentType));
    return this.http.post<T>(url, formData, { params });
  }

  // Get all documents (optionally filtered by type or application type)
   getAllDocuments<T = any>(endpoint: string, filters?: { gspDocType?: number; applicationTypeId?: number }): Observable<T> {
    let url = `${this.baseUrl}${endpoint}`;
    
    if (filters) {
      const params = new HttpParams()
        .set('gspDocType', String(filters.gspDocType || ''))
        .set('applicationTypeId', String(filters.applicationTypeId || ''));
      url += `?${params.toString()}`;
    }
    return this.http.get<T>(url);
  }

  // Generic method for getting by ID or with query params
  getById<T>(endpoint: string, params: { [key: string]: any }): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<T>(url, { params: httpParams });
  }

    // Delete a document by ID
    // deleteDocument<T = any>(documentId: number, endpoint: string = 'FileHandler/DeleteFileById?id='): Observable<T> {
    //   const url = `${this.baseUrl}${endpoint}${documentId}`;
    //   return this.http.delete<T>(url);
    // }


}


